import App from 'app/app.js';
import 'app/store/ShoppingCartStore.js';
import 'app/service/OrderLineFactory.js';

import UpgradeType from 'app/store/UpgradeType.js';
import 'app/service/ValidationService.js';

function LtEnhancementsCtrl(
  $scope,
  $rootScope,
  $timeout,
  ProductCatalogStore,
  OrderLineFactory,
  ShoppingCartStore,
  $window,
  SelectionTemplateDataStore,
  ValidationService,
  AnalyticsService,
  $location,
  $filter,
  $q
) {
  this.availableEnhancements = [];
  this.retouchingEnhancements = [];
  this.personalizationEnhancements = [];
  this.selectedPersonalizationEnhancement = null;
  this.selectedRetouchingEnhancement = null;
  this.isPersonalizationDataValid = false;
  this.showEnhancement = true;
  this.validationError = decodeURI($filter('ltTranslateFilter')('ENHANCEMENTS_VALIDATION_ERROR'));
  this.validationNogoError = decodeURI($filter('ltTranslateFilter')('ENHANCEMENTS_NOGO_VALIDATION_ERROR'));

  var directiveIsLoading = true;

  function getSortedSelectionTemplateMap(data) {
    var sortedFieldList = R.sortBy(R.prop('sortSequence'));
    data.fields.field = sortedFieldList(data.fields.field);
    return data;
  }

  this.init = function (sku) {
    var item = ProductCatalogStore.findBySku(sku);
    this.calculateAvailableEnhancements(item ? [item] : []);
  };

  this.getCurrentRoute = function () {
    return $location.url();
  };

  this.showHideEnhancement = function () {
    this.showEnhancement = !this.showEnhancement;
  };

  this.calculateAvailableEnhancements = function (currentItems, initialSelections) {
    directiveIsLoading = true;

    var selectedEnhancements = [],
      removeNull = function (item) {
        return !!item;
      };

    if (initialSelections) {
      selectedEnhancements = R.filter(
        removeNull,
        R.map(function (selection) {
          return selection;
        }, initialSelections.selectedEnhancements || [])
      );
    }
    if (selectedEnhancements.length === 0) {
      selectedEnhancements = ShoppingCartStore.getSelectedEnhancements($scope.options.orderIndex);
    }

    this.optOutOfPersonalizationEnhancement = initialSelections
      ? initialSelections.isPersonalizationEnhancementOptedOut
      : ShoppingCartStore.isPersonalizationEnhancementOptedOut($scope.options.orderIndex);
    this.optOutOfRetouchingEnhancement = initialSelections
      ? initialSelections.isRetouchingEnhancementOptedOut
      : ShoppingCartStore.isRetouchingEnhancementOptedOut($scope.options.orderIndex);
    if (this.optOutOfPersonalizationEnhancement) {
      this.selectedPersonalization = 'NO_PERSONALIZATION_PREFERENCE';
    }
    if (this.optOutOfRetouchingEnhancement) {
      this.selectedRetouching = 'NO_RETOUCHING_PREFERENCE';
    }
    if (selectedEnhancements.length > 0) {
      this.setSelectedEnhancements(selectedEnhancements);
    }

    // the currentItems would be from find by sku of product catalog
    this.availableEnhancements = ShoppingCartStore.getAvailableEnhancements(currentItems, $scope.options.orderIndex);
    this.personalizationEnhancements = R.filter(R.propEq('type', UpgradeType.PERSONALIZATION))(
      this.availableEnhancements
    );
    this.retouchingEnhancements = R.filter(R.compose(R.not, R.propEq('type', UpgradeType.PERSONALIZATION)))(
      this.availableEnhancements
    );

    var promises = [];
    this.personalizationEnhancements.forEach(
      function (personalizationEnhancement) {
        var promise = SelectionTemplateDataStore.getSelectionTemplateDataMap(
          personalizationEnhancement.templateName
        ).then(
          function (data) {
            personalizationEnhancement.selectionTemplateMap = getSortedSelectionTemplateMap(data);
            if (this.selectedPersonalizationEnhancement) {
              const fields =
                this.selectedPersonalizationEnhancement.orderLineDetails[0].item.orderLineItemSelections ||
                this.selectedPersonalizationEnhancement.orderLineDetails[0].item.selectionTemplateMap.fields.field;

              personalizationEnhancement.models = [];
              R.forEachIndexed(function (field, index) {
                personalizationEnhancement.models.push({ value: field.value });
              }, fields);
              /*
              Ensure deserialized objects are correctly linked for validation. After deserialization,
              personalization enhancements may reference different instances. This fix synchronizes objects
              to prevent false validation errors:
               */
              const selectedPersonalizationOrderable = this.selectedPersonalizationEnhancement.orderable;
              if (selectedPersonalizationOrderable.skuCode === personalizationEnhancement.skuCode) {
                selectedPersonalizationOrderable.models = personalizationEnhancement.models;
                selectedPersonalizationOrderable.selectionTemplateMap = personalizationEnhancement.selectionTemplateMap;
                personalizationEnhancement.selectionTemplateMap.fields.field[0].value = fields[0].value;
              }
            } else {
              R.forEachIndexed(function (field, index) {
                personalizationEnhancement.models = [{}];
              }, personalizationEnhancement.selectionTemplateMap.fields.field);
            }
            directiveIsLoading = false;
          }.bind(this)
        );
        promises.push(promise);
      }.bind(this)
    );

    $q.all(promises).then(
      function () {
        this.validatePersonalizationData();
      }.bind(this)
    );
  };

  this.isNameOnPersonalizationAvailable = function () {
    return R.any(function (e) {
      return e.nameDesc.toUpperCase().indexOf('NAME') > -1;
    })(this.personalizationEnhancements);
  };

  this.isPremiumRetouchAvailable = function () {
    return R.any(function (e) {
      return e.type.toUpperCase().indexOf(UpgradeType.PREMIUM_RETOUCHING) > -1;
    })(this.retouchingEnhancements);
  };

  this.onEnhancementSelected = function (productCode) {
    if (productCode.productCode === 'NO_PERSONALIZATION_PREFERENCE') {
      AnalyticsService.recordEnhancementSelected('PERSONALIZATION_NO_THANKS', true);
      if (!!this.selectedPersonalizationEnhancement) {
        var currentPersonalizationEnhancement = this.getCurrentPersonalizationEnhancement();
        if (
          !!currentPersonalizationEnhancement &&
          !!currentPersonalizationEnhancement.models &&
          !!currentPersonalizationEnhancement.models[0]
        ) {
          currentPersonalizationEnhancement.models[0].setFieldData('');
        }
      }
      this.optOutOfPersonalizationEnhancement = true;
      this.selectedPersonalizationEnhancement = null;
      this.isPersonalizationDataValid = true;
    } else if (productCode.productCode === 'NO_RETOUCHING_PREFERENCE') {
      AnalyticsService.recordEnhancementSelected('RETOUCHING_NO_THANKS', false);
      this.optOutOfRetouchingEnhancement = true;
      currentPersonalizationValue = '';
      this.selectedRetouchingEnhancement = null;
    } else {
      var currentPersonalizationValue = '';
      if (this.selectedPersonalizationEnhancement && !this.isRetouchingEnhancement(productCode.productCode)) {
        var currentModel = this.getCurrentPersonalizationEnhancement().models[0];
        currentPersonalizationValue = currentModel.getFieldData();
        currentModel.setFieldData('');
      } else {
        currentPersonalizationValue = ShoppingCartStore.getCurrentNoGoEnhancementData();
      }
      this.availableEnhancements.forEach(
        function (enhancement) {
          if (enhancement.productCode === productCode.productCode) {
            var enhancementOrderLine = OrderLineFactory.createFromEnhancement(enhancement);
            if (enhancement.type === UpgradeType.PERSONALIZATION) {
              AnalyticsService.recordEnhancementSelected(enhancement.subClass, true);
              this.selectedPersonalizationEnhancement = enhancementOrderLine;
              this.selectedPersonalizationEnhancement.orderable.models[0].setFieldData(currentPersonalizationValue);
              this.selectedPersonalizationEnhancement.orderable.selectionTemplateMap.fields.field[0].value =
                currentPersonalizationValue;
              this.optOutOfPersonalizationEnhancement = false;
              $timeout(() => {
                this.validatePersonalizationData();
              }, 1);
            } else {
              AnalyticsService.recordEnhancementSelected(enhancement.subClass, false);
              this.selectedRetouchingEnhancement = enhancementOrderLine;
              this.optOutOfRetouchingEnhancement = false;
            }
          }
        }.bind(this)
      );
    }
  };

  this.isRetouchingEnhancement = function (productCode) {
    var isRetouchingEnhancement = false;
    if (!!productCode && !!this.retouchingEnhancements) {
      R.forEach(function (retouchingEnhancement) {
        if (retouchingEnhancement.productCode === productCode) {
          isRetouchingEnhancement = true;
        }
      })(this.retouchingEnhancements);

      return isRetouchingEnhancement;
    }
  };

  this.getCurrentPersonalizationEnhancement = function () {
    var enh = R.find(
      R.propEq('productCode', this.selectedPersonalizationEnhancement.orderable.productCode),
      this.personalizationEnhancements
    );
    return enh || {};
  };

  this.enhancementNumberForBox = function (enhancementType) {
    var type = {
      RETOUCHING: 1,
      PERSONALIZATION: 2
    };
    return type[enhancementType];
  };

  this.onPersonalizationValueChanged = function () {
    var enh = this.getCurrentPersonalizationEnhancement();
    this.selectedPersonalizationEnhancement.orderable.selectionTemplateMap.fields.field[0].value =
      enh.models[0].getFieldData();
    this.selectedPersonalizationEnhancement.orderable.models = enh.models;
    // Ensure deserialized objects are correctly linked for validation:
    this.selectedPersonalizationEnhancement.orderLineDetails[0].item =
      this.selectedPersonalizationEnhancement.orderable;

    this.validatePersonalizationData();
  };

  this.validatePersonalizationData = () => {
    this.isPersonalizationDataValid = this.validateData();
  };

  this.validateData = function () {
    if (directiveIsLoading || this.optOutOfPersonalizationEnhancement || !this.selectedPersonalizationEnhancement) {
      return true;
    } else {
      var validations = [],
        errors = [];
      R.forEachIndexed(
        function (item, index) {
          validations = R.concat(validations, item.getValidationData());
        }.bind(this),
        this.selectedPersonalizationEnhancement.orderable.models
      );
      errors = ValidationService.validateSelectionTemplate(validations);

      var modelArray = this.selectedPersonalizationEnhancement.orderable.models;
      var personalizeValue =
        this.selectedPersonalizationEnhancement.orderable.selectionTemplateMap.fields.field[0].value;
      return (
        errors.length === 0 &&
        personalizeValue &&
        (modelArray && modelArray[0] ? !modelArray[0].isFieldDataInvalid() : true)
      );
    }
  };

  this.isValidUpgrade = function (availableUpgrades, selectedUpgrade, optOut) {
    return !availableUpgrades.length || (!!availableUpgrades.length && (!!selectedUpgrade || !!optOut));
  };

  this.isValid = function () {
    return (
      this.isValidUpgrade(
        this.retouchingEnhancements,
        this.selectedRetouchingEnhancement,
        this.optOutOfRetouchingEnhancement
      ) &&
      this.isValidUpgrade(
        this.personalizationEnhancements,
        this.selectedPersonalizationEnhancement,
        this.optOutOfPersonalizationEnhancement
      )
    );
  };

  this.scrollToError = function (valid, element) {
    if ($scope.hasTriedAddingToCart && !valid) {
      $window.scrollTo(0, element[0].offsetTop - 10);
    }
  };

  this.getSelectedUpgrades = function () {
    var ctrl = this;
    if (ctrl.selectedPersonalizationEnhancement?.orderable.selectionTemplateMap) {
      ctrl.selectedPersonalizationEnhancement.orderLineDetails[0] = OrderLineFactory.createOrderLineItemSelections(
        ctrl.selectedPersonalizationEnhancement.orderLineDetails[0],
        ctrl.selectedPersonalizationEnhancement.orderable.selectionTemplateMap.fields.field
      );
    }

    // Return selected upgrades. Convert orderLine to null in case it is undefined
    return [
      {
        // personalization
        isRetouching: false,
        optOut: ctrl.optOutOfPersonalizationEnhancement,
        orderLine: ctrl.selectedPersonalizationEnhancement || null
      },
      {
        // retouching
        isRetouching: true,
        optOut: ctrl.optOutOfRetouchingEnhancement,
        orderLine: ctrl.selectedRetouchingEnhancement || null
      }
    ];
  };

  this.setSelectedEnhancements = function (selectedEnhancements) {
    this.selectedPersonalizationEnhancement = null;
    this.selectedRetouchingEnhancement = null;

    if (selectedEnhancements) {
      selectedEnhancements.forEach(
        function (orderLine) {
          if (orderLine.orderable.type === UpgradeType.PERSONALIZATION) {
            this.selectedPersonalization = orderLine.orderable.productCode;
            this.selectedPersonalizationEnhancement = orderLine;
          } else if (
            orderLine.orderable.type === UpgradeType.PREMIUM_RETOUCHING ||
            orderLine.orderable.type === UpgradeType.BASIC_RETOUCHING
          ) {
            this.selectedRetouching = orderLine.orderable.productCode;
            this.selectedRetouchingEnhancement = orderLine;
          }
        }.bind(this)
      );
    }
  };

  this.getPlaceholder = function (contentKey) {
    return $filter('ltTranslateFilter')(contentKey);
  };
}

App.controller('LtEnhancementsCtrl', [
  '$scope',
  '$rootScope',
  '$timeout',
  'ProductCatalogStore',
  'OrderLineFactory',
  'ShoppingCartStore',
  '$window',
  'SelectionTemplateDataStore',
  'ValidationService',
  'AnalyticsService',
  '$location',
  '$filter',
  '$q',
  LtEnhancementsCtrl
]);
